import { Link } from "react-router-dom";

export const Logo = ({ variant = "dark", withText = true, className = "" }) => {
  const isLight = variant === "light";
  const markStroke = isLight ? "#FFFFFF" : "#0A192F";
  const accent = "#38BDF8";
  const textColor = isLight ? "text-white" : "text-navy";
  const subColor = isLight ? "text-sky" : "text-ocean";

  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="site-logo" aria-label="HM Services home">
      <span className="relative inline-flex h-11 w-11 items-center justify-center rounded-xl" style={{ background: isLight ? "rgba(255,255,255,0.08)" : "#0A192F" }}>
        <svg width="26" height="26" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <path d="M5 26V8" stroke={isLight ? "#FFFFFF" : "#FFFFFF"} strokeWidth="2.4" strokeLinecap="round" />
          <path d="M16 26V8" stroke={isLight ? "#FFFFFF" : "#FFFFFF"} strokeWidth="2.4" strokeLinecap="round" />
          <path d="M5 16h11" stroke={isLight ? "#FFFFFF" : "#FFFFFF"} strokeWidth="2.4" strokeLinecap="round" />
          <path d="M22 26V13l5-4v17" stroke={accent} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22 26h5" stroke={accent} strokeWidth="2.4" strokeLinecap="round" />
        </svg>
      </span>
      {withText && (
        <span className="flex flex-col leading-none">
          <span className={`font-serif text-lg font-bold tracking-tight ${textColor}`}>HM Services</span>
          <span className={`mt-0.5 text-[10px] font-medium uppercase tracking-[0.22em] ${subColor}`}>Hospitality Growth</span>
        </span>
      )}
    </Link>
  );
};
